import { render, staticRenderFns } from "./EditDiscount.vue?vue&type=template&id=555e86fe&"
import script from "./EditDiscount.vue?vue&type=script&lang=ts&"
export * from "./EditDiscount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports